import React from 'react';

// eslint-disable-next-line no-restricted-imports
import { useFeatureFlags } from 'src/context/flagsContext';

import type { TableProps } from './Table.types';

export * from './AgGridContext';
export type { TableProps } from './Table.types';

/* eslint-disable no-restricted-imports -- v27↔v35 migration: legacy v27 submodules (HeaderRender / Renderer / TableResultCount / legacy Table) remain in src/legacy until Phase 5 of the rollout. */
// TODO: we will move these out off legacy
export * from 'src/legacy/components/AgGrid/HeaderRender';

export {
  BaseStatusIndicator,
  ClientActionRenderer,
  CompanyCellRenderer,
  CustomFieldsRenderer,
  FileCellRendererV2,
  FilesActionsRenderer,
  IconWrapper,
  ImageRenderer,
  InvoiceActionRenderer,
  LiveCheckRenderer,
  MemberActionRenderer,
  UserCellRenderer,
} from 'src/legacy/components/AgGrid/Renderer';
export type { CustomFieldsRendererProps } from 'src/legacy/components/AgGrid/Renderer/CustomFieldsRenderer';
export * from 'src/legacy/components/AgGrid/TableResultCount';
export type { SortParams } from 'src/legacy/components/AgGrid/Table';
/* eslint-enable no-restricted-imports */

// TODO: AG Grid v27→v35 migration — remove the legacy lazy import and
// the flag-gated branch below once the v35 rollout is complete (Phase 5
// of the migration). Both branches are lazy so the legacy v27 chunk
// (JS + SCSS) and the v35 chunk (JS + portalTheme CSS) each only load
// when their branch renders, preventing cross-contamination of
// `.ag-theme-portal` rules in either direction. The v35 Table accepts
// the same TableProps shape as the legacy component so callers don't
// need to migrate their ColDefs during the rollout.
const LegacyTable = React.lazy(
  () =>
    import(
      /* webpackChunkName: "legacy-ag-grid-table" */

      'src/legacy/components/AgGrid/Table'
    ),
);

const NewTable = React.lazy(
  () => import(/* webpackChunkName: "ag-grid-v35" */ './Table'),
);

const Table = <TData = Record<string, unknown>,>(
  props: TableProps<TData>,
): React.ReactElement => {
  const { EnableAgGridUpgrade } = useFeatureFlags();
  const Inner = (EnableAgGridUpgrade
    ? NewTable
    : LegacyTable) as unknown as React.ComponentType<TableProps<TData>>;
  return (
    <React.Suspense fallback={null}>
      <Inner {...props} />
    </React.Suspense>
  );
};

export default Table;
